var map = {
	"./aiSecurity/en.json": [
		4256,
		65
	],
	"./dataLeakage/en.json": [
		4257,
		68
	],
	"./ppd/en.json": [
		4258,
		71
	],
	"./ransomware/en.json": [
		4259,
		74
	],
	"./socialMedia/en.json": [
		4260,
		77
	],
	"./whatsApp/en.json": [
		4261,
		80
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1428;
module.exports = webpackAsyncContext;